// extracted by mini-css-extract-plugin
export default {"container":"Collab_container__+Vmoq","images_list":"Collab_images_list__AUG4H","image":"Collab_image__qWz2W"};